import { useState, useEffect } from 'react';

// Phone-sized viewports get the dedicated mobile app (see MobileApp.jsx); every
// width above this keeps the desktop shell untouched. 768px is the tablet
// boundary — an iPad in portrait still has room for the desktop tab bar.
export const MOBILE_QUERY = '(max-width: 768px)';

export default function useIsMobile(query = MOBILE_QUERY) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && !!window.matchMedia?.(query).matches,
  );

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    const onChange = e => setMatches(e.matches);
    setMatches(mq.matches);
    // addListener is the Safari < 14 spelling; still worth keeping for iOS.
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, [query]);

  return matches;
}
